import React from 'react';
import { useTheme } from '../../../context/ThemeContext';
import CustomCard from '../../Scanners/components/CustomCard';

/**
 * Skeleton loader for Stock Info Card
 */
const StockInfoSkeleton = () => {
  const { theme } = useTheme();

  return (
    <CustomCard className="p-6">
      {/* Stock Header */}
      <div className="flex items-start justify-between mb-1">
        <div>
          <div className="h-4 w-32 bg-n200 rounded animate-pulse"></div>
          <div className="h-6 w-48 bg-n200 rounded animate-pulse mt-2"></div>
        </div>
        <div className="w-11 h-11 bg-n200 rounded-[6px] animate-pulse"></div>
      </div>

      {/* Price + Change */}
      <div className="flex items-center mb-3 mt-4">
        <div className="h-6 w-32 bg-n200 rounded animate-pulse"></div>
        <div className="h-4 w-16 bg-n200 rounded animate-pulse ml-2"></div>
      </div>

      {/* Divider */}
      <div
        className={`border-t my-4 -mx-6 ${theme === 'dark' ? 'border-[#1F1F1F]' : 'border-[#EBEBEB]'
          }`}
      />

      {/* OHLC */}
      <div className="mb-4">
        <div className="flex items-end justify-between">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="flex flex-col items-center gap-2">
              <div className="h-3 w-12 bg-n200 rounded animate-pulse"></div>
              <div className="h-4 w-16 bg-n200 rounded animate-pulse"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Divider */}
      <div
        className={`border-t my-4 -mx-6 ${theme === 'dark' ? 'border-[#1F1F1F]' : 'border-[#EBEBEB]'
          }`}
      />

      {/* Buy / Sell */}
      <div className="grid grid-cols-2 gap-3 mb-4">
        <div className="h-10 bg-n200 rounded-[6px] animate-pulse"></div>
        <div className="h-10 bg-n200 rounded-[6px] animate-pulse"></div>
      </div>

      {/* Option Chain */}
      <div className="h-10 bg-n200 rounded-[6px] animate-pulse mb-4"></div>

      {/* Today's Trend */}
      <div className="flex items-center justify-center gap-3">
        <div className="h-4 w-24 bg-n200 rounded animate-pulse"></div>
        <div className="h-4 w-16 bg-n200 rounded animate-pulse"></div>
      </div>
    </CustomCard>
  );
};

export default StockInfoSkeleton;
